$shm_surreal_profile_form $mol_list
	profile_id \local
	draft? null
	status? \
	endpoint? \
	namespace? \
	database? \
	username? \
	password? \
	sub /
		<= Endpoint_label $mol_labeler
			title \Адрес сервера
			Content <= Endpoint $mol_string
				value? <=> endpoint?
				hint \wss://db.example/rpc
		<= Namespace_label $mol_labeler
			title \Namespace
			Content <= Namespace $mol_string
				value? <=> namespace?
		<= Database_label $mol_labeler
			title \Database
			Content <= Database $mol_string
				value? <=> database?
		<= Username_label $mol_labeler
			title \Пользователь
			Content <= Username $mol_string
				value? <=> username?
		<= Password_label $mol_labeler
			title \Пароль
			Content <= Password $mol_string
				type \password
				value? <=> password?
		<= Save $mol_button_major
			title \Сохранить подключение локально
			click? <=> save? null
		<= Status $mol_view
			sub / <= status?
